import { GET_ALL_PUBLIC_IPS, UPDATE_VM_BILLING_TYPE, UPDATE_VM_DOMAIN_NAME } from "../../infrastructure/graphql/domainNameQuerries";
import { client } from "../../infrastructure/graphql/client";
export class DomainService {
  async getAllVmsWithPublicIp() {
    try {
      const result = await client.query({
        query: GET_ALL_PUBLIC_IPS,
        fetchPolicy: "network-only",
      });

      const response = result.data?.getAllVmsWithPublicIp;

      if (!response) {
        return { success: false, message: "No response from server", vms: null };
      }

      return {
        success: true,
        vms: response,
      };
    } catch (error) {
      console.error("Get all VMs with public IP error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, vms: null };
    }
  }

  async updateVmDomainName(vmId, domainName) {
    try {
      const result = await client.mutate({
        mutation: UPDATE_VM_DOMAIN_NAME,
        variables: { vmId, domainName },
      });

      const response = result.data?.updateVmDomainName;

      if (!response) {
        return { success: false, message: "No response from server" };
      }

      if (response && response.includes("Domain name updated successfully")) {
        return {
          success: true,
          message: response,
        };
      } else {
        return {
          success: false,
          message: response || "Update failed",
        };
      }
    } catch (error) {
      console.error("Update VM domain name error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage };
    }
  }

   async updateVmBillingType(vmId, billingType) {
        try {
            const result = await client.mutate({
                mutation: UPDATE_VM_BILLING_TYPE,
                variables: { vmId, billingType },
            });

            const response = result.data?.updateVmBillingType;

            if (response === true) {
                return {
                    success: true,
                    message: "Billing type updated successfully",
                };
            } else {
                return {
                    success: false,
                    message: "Failed to update billing type",
                };
            }
        } catch (error) {
            console.error("Update VM billing type error:", error);
            const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
            return {
                success: false,
                message: errorMessage,
            };
        }
    }
}